<script setup lang="ts">
defineProps<{ mood: 'friendly' | 'professional' }>()
</script>

<template>
  <svg
    v-if="mood === 'friendly'"
    viewBox="0 0 48 52"
    fill="none"
    style="overflow:visible"
  >
    <g class="cmo-spark-a">
      <g transform="translate(2,9)">
        <line x1="0" y1="-4.5" x2="0" y2="4.5" stroke="#FCD34D" stroke-width="2.2" stroke-linecap="round"/>
        <line x1="-4.5" y1="0" x2="4.5" y2="0" stroke="#FCD34D" stroke-width="2.2" stroke-linecap="round"/>
        <line x1="-3.2" y1="-3.2" x2="3.2" y2="3.2" stroke="#FCD34D" stroke-width="1.4" stroke-linecap="round" opacity="0.7"/>
        <line x1="3.2" y1="-3.2" x2="-3.2" y2="3.2" stroke="#FCD34D" stroke-width="1.4" stroke-linecap="round" opacity="0.7"/>
      </g>
    </g>
    <g class="cmo-spark-b">
      <g transform="translate(46,7)">
        <line x1="0" y1="-3.5" x2="0" y2="3.5" stroke="#F59E0B" stroke-width="1.8" stroke-linecap="round"/>
        <line x1="-3.5" y1="0" x2="3.5" y2="0" stroke="#F59E0B" stroke-width="1.8" stroke-linecap="round"/>
        <line x1="-2.5" y1="-2.5" x2="2.5" y2="2.5" stroke="#F59E0B" stroke-width="1.1" stroke-linecap="round" opacity="0.6"/>
        <line x1="2.5" y1="-2.5" x2="-2.5" y2="2.5" stroke="#F59E0B" stroke-width="1.1" stroke-linecap="round" opacity="0.6"/>
      </g>
    </g>

    <g class="cmo-bounce">
      <circle cx="24" cy="4.6" r="3" fill="#FCD34D"/>
      <rect x="22.5" y="6" width="3" height="5.5" rx="1.5" fill="#F59E0B"/>
      <circle cx="6" cy="28" r="3.5" fill="#D97706"/>
      <circle cx="42" cy="28" r="3.5" fill="#D97706"/>
      <rect x="8" y="11" width="32" height="33" rx="12" fill="#F59E0B"/>
      <ellipse cx="20" cy="17" rx="7" ry="4" fill="white" fill-opacity="0.2" transform="rotate(-8 20 17)"/>
      <path d="M22.8 6.9 C 20.4 4, 16.2 3.6, 14.4 5.2 C 12.6 6.8, 12.6 10.4, 14.4 12 C 16.2 13.6, 20.4 13, 22.8 10.3 Z M25.2 6.9 C 27.6 4, 31.8 3.6, 33.6 5.2 C 35.4 6.8, 35.4 10.4, 33.6 12 C 31.8 13.6, 27.6 13, 25.2 10.3 Z" fill="#004AAD" stroke="#93c5fd" stroke-width="0.5" stroke-opacity="0.6"/>
      <circle cx="24" cy="8.6" r="2.2" fill="#003a8a"/>
      <circle cx="17.2" cy="6.9" r="0.85" fill="white" fill-opacity="0.55"/>
      <circle cx="16.4" cy="10.4" r="0.75" fill="white" fill-opacity="0.5"/>
      <circle cx="30.8" cy="6.9" r="0.85" fill="white" fill-opacity="0.55"/>
      <circle cx="31.6" cy="10.4" r="0.75" fill="white" fill-opacity="0.5"/>

      <circle cx="16" cy="26" r="6.5" fill="white"/>
      <circle cx="16" cy="24.5" r="4.5" fill="#004AAD"/>
      <circle cx="17.2" cy="23.2" r="1.7" fill="white" fill-opacity="0.85"/>

      <circle cx="32" cy="26" r="6.5" fill="white"/>
      <circle cx="32" cy="24.5" r="4.5" fill="#004AAD"/>
      <circle cx="33.2" cy="23.2" r="1.7" fill="white" fill-opacity="0.85"/>

      <ellipse cx="8" cy="33" rx="6" ry="3.5" fill="#F97316" fill-opacity="0.3"/>
      <ellipse cx="40" cy="33" rx="6" ry="3.5" fill="#F97316" fill-opacity="0.3"/>

      <path d="M 12 36 Q 24 43 36 36" stroke="#92400E" stroke-width="2.8" stroke-linecap="round" fill="none" opacity="0.9"/>

      <path d="M10.8 23 L 8.8 21.5 M12.4 20.6 L 11.3 18.7" stroke="#92400E" stroke-width="1.6" stroke-linecap="round" opacity="0.85"/>
      <path d="M37.2 23 L 39.2 21.5 M35.6 20.6 L 36.7 18.7" stroke="#92400E" stroke-width="1.6" stroke-linecap="round" opacity="0.85"/>

      <rect x="20.5" y="42.5" width="7" height="3.6" fill="#D97706"/>
      <circle cx="12.6" cy="48.8" r="3.4" fill="#004AAD"/>
      <circle cx="35.4" cy="48.8" r="3.4" fill="#004AAD"/>
      <path d="M13 46.2 Q24 51.8 35 46.2 L 39.5 52 L 8.5 52 Z" fill="#004AAD"/>
      <path d="M18.6 47.9 Q24 50.8 29.4 47.9 L 27.8 50.2 Q24 52 20.2 50.2 Z" fill="white" fill-opacity="0.9"/>
    </g>
  </svg>

  <svg
    v-else
    viewBox="0 0 48 52"
    fill="none"
    style="overflow:visible"
  >
    <g class="cmo-nod">
      <circle cx="24" cy="4.6" r="3" fill="#FCD34D"/>
      <rect x="22.5" y="6" width="3" height="5.5" rx="1.5" fill="#F59E0B"/>
      <circle cx="6" cy="28" r="3.5" fill="#D97706"/>
      <circle cx="42" cy="28" r="3.5" fill="#D97706"/>
      <rect x="8" y="11" width="32" height="33" rx="12" fill="#F59E0B"/>
      <ellipse cx="20" cy="17" rx="7" ry="4" fill="white" fill-opacity="0.2" transform="rotate(-8 20 17)"/>
      <path d="M22.8 6.9 C 20.4 4, 16.2 3.6, 14.4 5.2 C 12.6 6.8, 12.6 10.4, 14.4 12 C 16.2 13.6, 20.4 13, 22.8 10.3 Z M25.2 6.9 C 27.6 4, 31.8 3.6, 33.6 5.2 C 35.4 6.8, 35.4 10.4, 33.6 12 C 31.8 13.6, 27.6 13, 25.2 10.3 Z" fill="#004AAD" stroke="#93c5fd" stroke-width="0.5" stroke-opacity="0.6"/>
      <circle cx="24" cy="8.6" r="2.2" fill="#003a8a"/>
      <circle cx="17.2" cy="6.9" r="0.85" fill="white" fill-opacity="0.55"/>
      <circle cx="16.4" cy="10.4" r="0.75" fill="white" fill-opacity="0.5"/>
      <circle cx="30.8" cy="6.9" r="0.85" fill="white" fill-opacity="0.55"/>
      <circle cx="31.6" cy="10.4" r="0.75" fill="white" fill-opacity="0.5"/>

      <circle cx="16" cy="26" r="6.5" fill="white"/>
      <circle cx="16" cy="26" r="3.6" fill="#004AAD"/>
      <circle cx="17.1" cy="24.7" r="1.3" fill="white" fill-opacity="0.85"/>
      <circle cx="32" cy="26" r="6.5" fill="white"/>
      <circle cx="32" cy="26" r="3.6" fill="#004AAD"/>
      <circle cx="33.1" cy="24.7" r="1.3" fill="white" fill-opacity="0.85"/>

      <rect x="9.5" y="20.5" width="13" height="11" rx="3" stroke="#1e293b" stroke-width="2.2" fill="none"/>
      <rect x="25.5" y="20.5" width="13" height="11" rx="3" stroke="#1e293b" stroke-width="2.2" fill="none"/>
      <line x1="22.5" y1="25.5" x2="25.5" y2="25.5" stroke="#1e293b" stroke-width="1.8"/>
      <line x1="9.5" y1="25.5" x2="6.5" y2="27.5" stroke="#1e293b" stroke-width="1.6" stroke-linecap="round"/>
      <line x1="38.5" y1="25.5" x2="41.5" y2="27.5" stroke="#1e293b" stroke-width="1.6" stroke-linecap="round"/>
      <circle cx="12.5" cy="22.5" r="2.5" fill="white" class="cmo-gleam"/>

      <path d="M 17 34 Q 24 37 31 34" stroke="#92400E" stroke-width="1.8" stroke-linecap="round" fill="none" opacity="0.6"/>

      <path d="M 11 40 L 11 44 L 20 44 L 22 42 L 17 40 Z" fill="#1e3a8a"/>
      <path d="M 37 40 L 37 44 L 28 44 L 26 42 L 31 40 Z" fill="#1e3a8a"/>

      <polygon points="17,40 22,42 22,44 26,44 26,42 31,40 24,38" fill="white" fill-opacity="0.93"/>

      <path d="M 22.5 42 L 24 39 L 25.5 42 L 24.8 45 L 23.2 45 Z" fill="#0f172a"/>
      <path d="M 23.2 45 L 22 49.5 L 24 51.5 L 26 49.5 L 24.8 45 Z" fill="#0f172a"/>
      <line x1="24" y1="42.5" x2="23.5" y2="49.5" stroke="white" stroke-width="0.9" stroke-opacity="0.3" stroke-linecap="round"/>
    </g>
  </svg>
</template>

<style scoped>
@keyframes cmo-bounce {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  30%       { transform: translateY(-5px) rotate(2deg); }
  65%       { transform: translateY(-2px) rotate(-1deg); }
}
.cmo-bounce { animation: cmo-bounce 1.0s ease-in-out infinite; }

@keyframes cmo-sparkle {
  0%, 100% { opacity: 0; transform: scale(0.5) rotate(0deg); }
  40%, 60%  { opacity: 1; transform: scale(1) rotate(20deg); }
}
.cmo-spark-a { animation: cmo-sparkle 1.7s ease-in-out infinite; }
.cmo-spark-b { animation: cmo-sparkle 1.7s ease-in-out infinite 0.57s; }

@keyframes cmo-nod {
  0%, 100% { transform: translateY(0); }
  35%, 65% { transform: translateY(-2px); }
}
.cmo-nod { animation: cmo-nod 2.8s ease-in-out infinite; }

@keyframes cmo-gleam {
  0%, 60%, 100% { opacity: 0; }
  30%, 45%      { opacity: 0.85; }
}
.cmo-gleam { animation: cmo-gleam 2.8s ease-in-out infinite; }
</style>
